var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Modal'),_c('Banner'),_c('b-container',{attrs:{"fluid":"xl"}},[(_vm.showObj[1])?_c('EcellectGoods'):_vm._e(),(_vm.showObj[2])?_c('HotGoods'):_vm._e(),(_vm.showObj[3] || _vm.showObj[4])?_c('NewsCenter'):_vm._e()],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }